import React from "react";
import Button from "@mui/material/Button";
import Badge from "@mui/material/Badge";
import LayersIcon from "@mui/icons-material/Layers";

const IngredientsSelectButton = ({ count = 0, onClick }) => {
  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={onClick}
      className="w-full"
      startIcon={
        count > 0 ? (
          <Badge badgeContent={count} color="primary">
            <LayersIcon />
          </Badge>
        ) : (
          <LayersIcon />
        )
      }
    >
      {count > 0 ? `${count} Ingredients Selected` : "Select Ingredients"}
    </Button>
  );
};

export default IngredientsSelectButton;
